import {
    List,
    Button,
    ListItem,
    Divider
} from '@mui/material';
import {
} from '@mui/icons-material';
import { NavLink as RouterLink } from 'react-router-dom';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import React from 'react';

const SuperAdminNavList = () => {

    const townshipDetails = useSelector(
        (store: RootState) => store.township.townshipDetails
    );

    const listItems = [
        {
            label: 'Township Management',
            icon: <LocationCityIcon />,
            to: `/township-management/${townshipDetails?.id}`,
        },
        {
            label: 'Dept. Management',
            icon: <CorporateFareIcon />,
            to: `/department-management/${townshipDetails?.id}`,
        },
        {
            label: 'Permit Management',
            icon: <AppSettingsAltIcon />,
            to: `/permit-management/${townshipDetails?.id}`,
        }
    ];

    return (
        <List component="div" className="menu-list">
            {
                listItems.map((item, index) => (
                    <React.Fragment key={index}>
                        <ListItem>
                            <Button
                                disableRipple
                                component={RouterLink}
                                to={item.to}
                                className='menu-link'
                                startIcon={item.icon}
                            >
                                {item.label}
                            </Button>
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                ))
            }
        </List>
    )
}

export default SuperAdminNavList;